import * as m from '~/paraglide/messages'

/** The line under the photos while a menu is read; nothing counts as found before the first dish. */
export function readingProgressLabel(dishes: number | null): string {
  if (!dishes) return m.menuReadingStarted()
  return dishes === 1 ? m.menuReadingDishesOne() : m.menuReadingDishes({ count: dishes })
}
